module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"Message","placeholders":"Available placeholders: ","required":"@:labels.required","subject":"Subject"},"fr":{"message":"Message","placeholders":"Balises disponibles: ","required":"@:labels.required","subject":"Sujet"}}')
  delete Component.options._Ctor
}
